module.exports = __webpack_public_path__ + "static/img/surface11.131ab58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surface11.png
// module id = cPVM
// module chunks = 2